import { render, staticRenderFns } from "./EditForm.vue?vue&type=template&id=0a524bca&scoped=true"
import script from "./EditForm.vue?vue&type=script&lang=js"
export * from "./EditForm.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./EditForm.vue?vue&type=style&index=1&id=0a524bca&prod&lang=scss&scoped=true"
import style2 from "./formstyles.scss?vue&type=style&index=2&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a524bca",
  null
  
)

export default component.exports